const registerFocusable = (id, input) => () => {
};
const unregisterFocusable = (id) => {
};
const focusFocusable = (id) => {
};
export {
  focusFocusable,
  registerFocusable,
  unregisterFocusable
};
//# sourceMappingURL=registerFocusable.js.map
